/* 🤖 this file was generated by svg-to-ts */
export const matIconMusicOff: {
  name: 'music-off';
  data: string;
} = {
  name: 'music-off',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M14 7h4V3h-6v4.61l2 2zm-2 3.44L4.41 2.86 3 4.27l9 9v.28c-.94-.54-2.1-.75-3.33-.32-1.34.48-2.37 1.67-2.61 3.07a4.007 4.007 0 0 0 4.59 4.65c1.96-.31 3.35-2.11 3.35-4.1v-1.58L19.73 21l1.41-1.41L12 10.44zM10 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/></svg>`
};
